import * as React from "react";
export function useWindow({ url = "", features = {}, target, onClose = () => undefined, }) {
    return React.useMemo(() => {
        const featureList = Object.entries(features)
            .map(([prop, value]) => prop + (typeof value === "number" ? `=${value}` : ""))
            .sort()
            .join(",");
        const wndo = window.open(url, target, featureList);
        if (wndo) {
            wndo.onbeforeunload = onClose;
            if (target && !url)
                wndo.document.title = target;
        }
        return wndo;
    }, [features, onClose, target, url]);
}
